import React, { useState, useEffect } from "react";
import ReactLoading from 'react-loading';
import LoaderImg from '../../assets/images/loader.gif'
import Header from "../../components/common/Header";
import EditAvatar from "../../components/EditProfile/EditAvatar";
import EditProfileInfo from "../../components/EditProfile/EditProfileInfo";
import EditCourseDetails from "../../components/EditProfile/EditCourseDetails";
import Documents from "../../components/EditProfile/Documents";
import ProfileList from "../../components/Student/ProfileList";
import PayFeeOnline from "../../components/Student/PayFeeOnline";
import { Link as ToastLink, useNavigate,useLocation } from "react-router-dom";
import {
  getProfileDetail,
  getProfileList,
  getSelectedDetail,
  isProfileComplete,
  isProfileConfirmed
  
} from "../../actions/StudentAction";
import Toast from "../../components/common/Toast";
import Link from "react-scroll/modules/components/Link";
import EnrollmentDetail from "../../components/Student/EnrollmentDetail";
import FamilyDetail from "../../components/Student/FamilyDetail";
import AreaDetail from "../../components/Student/AreaDetail";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBus,faWarning} from '@fortawesome/free-solid-svg-icons';




const EditProfile = (props) => {
  const navigate = useNavigate();
  const [profileDetail, setProfileDetail] = useState({});
  const [profileList, setProfileList] = useState([]);
  const [enablePayFee,setEnablePayFee] = useState(false)
  const [loading,setLoading] = useState(true)
  const [selectedProfileId,setPofileId] = useState(undefined);
  const location=useLocation();
  const [confirmProfilePicture,setConfirmProfilePicture] = useState(false);



  const enablePayFeeBox = () => {
    setEnablePayFee(!enablePayFee)
    // alert('desktiop')
  }

  let form_number = profileDetail?.form_num;
  let form_number_encode = window.btoa(form_number);

  useEffect(async() => {
    sessionStorage.getItem("userDetail") ? navigate("/dashboard") : navigate("/login");

      if(location &&location.state!==null){
        const {detail}=location.state
        if(detail!==null){
          setPofileId(detail.id)
          getSelectedProfileDetail(detail.id)
        }
    }

    if(selectedProfileId!==undefined){
      getSelectedProfileDetail(selectedProfileId)
    }

    if(location &&location.state!==null){
      const {detail}=location.state
      if(detail!==undefined){
        setPofileId(detail.id)
        getSelectedProfileDetail(detail.id)
      }
  }

    else{
      getProfileDetail().then((res) => {
        setProfileDetail(res.data);
        setLoading(false)
      }
      );
    }

    getProfileList().then((res) => {
      setProfileList(res.data);
    });

  }, [location.state]);

  useEffect(() => {
    if(profileDetail!==undefined){
        if(profileDetail.profile_picture && profileDetail.profile_picture_confirmed ==0){
          setConfirmProfilePicture(true);
        } 
    }
},[profileDetail])

  const getSelectedProfileDetail = (id) => {
    setLoading(true)
    getSelectedDetail(id).then((res) => {
      
      if(res.status){
        setProfileDetail(res.data);
        setLoading(false)
      }
      
    });
  };



  const getPersonalDetail = (id) => {
    getSelectedDetail(id).then((res) => {
      setProfileDetail(res.data);
    });
  };

  const updateDetail = (res) => {
    const { id } = res.data;
    getPersonalDetail(id);
  };

  const handleDocUpload = (res) => {
    const { id } = res.data;
    getPersonalDetail(id);
  };

  const handleDelete = (id) => {
    getPersonalDetail(id);
  };

  const handleProfPicUpload = (res) => {
    const {id } = res.data;
    getPersonalDetail(id);
    getProfileList().then((res) => {
      setProfileList(res.data);
    });
  };

  const handleUpdateCompletePorfile = () => {
    const data = {
      student_id:profileDetail.id,
      is_profile_complete:0
  }
    isProfileComplete(data).then(res => {
      if(res.status){
        getSelectedProfileDetail(res.data.id)
      }
    })
  }

  const handleUpdateconfirmedProfilePicture = () => {
    const data = {
      student_id:profileDetail.id,
      profile_picture_confirmed:1
  }
    isProfileConfirmed(data).then(res => {
      if(res.status){
        setConfirmProfilePicture(false);
      }
    })
  }


  let result = profileDetail !==undefined && profileDetail.ttxResult
  let resultSummary = result !==undefined && result.summary
 

  const setLoader=(val)=>{
    setLoading(val)
  }
  return (
    <>
    {loading ? <div className="screenLoader text-center flex-wrap">
      <img src={LoaderImg} alt="Loading..." style={{width:'140px'}}/>
      {/* <h6 className="d-block w-100 text-black fw-bold mb-2">Loading</h6>
      <ReactLoading type={"cubes"} className="flex-shrink-1" width={60} height={50}  color={"#20367f"}/> */}
      </div>:
    <>
      <Header detail={profileDetail} />
      {/* {resultDetail !==undefined && resultSummary.cash_prize !== null && 
                                        <div className='cash_prizeWinnerWrap'>
                                        <h5 className='rank_title'>Congratulations you have won {feeDetail!==undefined&& feeDetail.scholarship_percentage}% scholarship and cash reward of Rs {resultDetail !==undefined && resultSummary.cash_prize} amount (if any) based on your TALLENTEX Overseas 2023 Performance. </h5>
                                        </div>
                                } */}
      <section className="pt-5 pb-5 content-section">

       {/* {profileDetail!==undefined && profileDetail.tx_is_appeared !== 0 &&
        <div className="container position-relative mb-2">
          <div className="row">
            <div className="col-lg-10 mx-auto">
            <div className="toast_dash_wrap">
            {resultSummary.cash_prize !== null &&
              <Toast 
                toastDetail={`Congratulations you have won
                 cash reward of Rs ${resultSummary !==undefined && resultSummary.cash_prize} amount based on your TALLENTEX Overseas 2023 Performance.`}>
                  &nbsp; <ToastLink to={`/bank-detail/${profileDetail?.id}`} className="btn mt-2 btn-primary btn-sm">Click here to fill Bank Details</ToastLink>
                </Toast> 
              }

            </div>
            </div>
          </div>
        </div>
 }   */}

{confirmProfilePicture &&
        <>
        <div className="overlay_popup"></div>
        <div className="modal-body rounded text-center bg-white p-5 shadow-sm w-50 mx-auto profile_complete_msg">
                <FontAwesomeIcon icon={faWarning} size='2xl' beatFade color='tomato' className='mb-3'/>
                <h4 className="fw-bold mb-4">
                Please confirm if you have uploaded an original recent photograph of yourself, as this will be used for all your academic purposes. </h4>
                <p className="text-center"> Please go back and change if you have not, else click Confirm.</p>
                <button className="btn mt-3 btn-primary px-5" onClick={handleUpdateconfirmedProfilePicture}>Confirm</button>
                <button  className="btn mt-3 ms-2 btn-secondary py-2 px-5" onClick={(e) => setConfirmProfilePicture(false)}>Go Back</button>

          </div>
          </>
        }

          {!profileDetail.profile_picture ? 
          <div className="container position-relative">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div  className="alert  d-flex align-items-center" role="alert" style={{backgroundColor:'#e3d86d'}}>
                  <div>
                    <FontAwesomeIcon icon={faWarning} className="me-3"/> Please upload your photo to complete your profile.
                  </div>
              </div>
            </div>
          </div>
        </div>
         
          : ''}
     


      {profileDetail!==undefined && profileDetail.profCompletePercentage !==100 &&
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-10 mx-auto">
            <div className="toast_dash_wrap">
              <Toast className="bg-warning text-black"
                toastDetail="Dear Student, Please complete your profile 100% to start your ALLEN Overseas Classes successfully for the session 2023-24."/>
            </div>
            </div>
          </div>
        </div>
        }

        {profileDetail !==undefined && profileDetail.is_paid == 1 ?
        <>
        {
          profileDetail.father_name !== "" && profileDetail.parent_mobile !=="" ? ''
        :  <div className="container mt-3 position-relative">
        <div className="row">
          <div className="col-lg-10 mx-auto">
          <div className="toast_dash_wrap">
            <Toast 
              toastDetail="Please complete the family details in order to dispatch the study material without any delay." className="bg-secondary text-dark"/>
          </div>
          </div>
        </div>
      </div>
        }
        </> 
        
        :''
        }

        {/* Modal Profile completion */}
        {profileDetail!==undefined && (profileDetail.is_profile_complete ==1 && profileDetail.profCompletePercentage ==100 )&&
        <>
        <div className="overlay_popup"></div>
        <div className="modal-body rounded text-center bg-white p-5 shadow-sm w-50 mx-auto profile_complete_msg">
                <p className="text-center">
                <h3 className="fw-bold text-primary mb-4">Congratulations!</h3> You have successfully enrolled with the ALLEN Overseas<br/>
                ALLEN Overseas Form No. - {profileDetail.form_num}<br/>
                Course - {profileDetail.course}<br/><br/>

                Wish you a happy learning!<br/>
                ALLEN Makes it possible
                </p>
                <button className="btn mt-3 btn-primary px-5" onClick={handleUpdateCompletePorfile}>Go to profile</button>
                <a href="https://digitalclass.allenoverseas.com/login" target="_blank"  className="btn mt-3 ms-2 btn-success px-5" onClick={handleUpdateCompletePorfile}>Go to LMS</a>

          </div>
          </>
}
        

        <div className="container">
          <div className="row mt-4">
            <ProfileList
              list={profileList}
              detail={profileDetail}
              onClick={getSelectedProfileDetail}
            />
          </div>
          <div className="row edit_profilePage justify-content-center ">
            <div className="col-lg-10">
              {profileDetail !== undefined && (
                <EditAvatar detail={profileDetail}  showPayFeeBox={enablePayFeeBox} feeDetail={profileDetail.feeDetail} onSubmit={handleProfPicUpload} />
              )}

              {/* {profileDetail!==undefined && profileDetail.is_paid ==1 &&
              <div className="pshycho_testBtn text-end mb-3">
                <a href={`https://asat.allenoverseas.com/login?fno=${profileDetail?.form_num}`} target="_blank" className="psychometric_btn btn-primary">Start ASAT Exam</a>
              </div>
            }  */}
             
              
             {/* {profileDetail!==undefined && profileDetail.is_paid ==1 &&
              <div className="pshycho_testBtn text-end mb-3">
                <a href={`https://asat.allenoverseas.com/login?fno=${profileDetail?.form_num}`} target="_blank" className="psychometric_btn btn-primary">Start ASAT Exam</a>
              </div>
            }  */}
             
              
              {/* {profileDetail!==undefined && profileDetail.tx_is_appeared !== 0 &&
              <div className="pshycho_testBtn text-end mb-3">
                <a href="http://psychometrictest.allenoverseas.com/" target="_blank" className="psychometric_btn btn-primary">Psychometric test</a>
              </div>
            } */}
      
              { profileDetail !== undefined &&<PayFeeOnline detail={profileDetail} setLoader={setLoader} enablePayFee={enablePayFee} fee={profileDetail.feeDetail}/>}
             
              {profileDetail !== undefined && (
                <EnrollmentDetail
                  detail={profileDetail}
                  onSubmit={updateDetail}
                />
              )}

            { profileDetail !== undefined && profileDetail?.category_id===3 && <Documents detail={profileDetail}
              handleDocUpload={handleDocUpload} handleDelete={handleDelete} />}
              
              {profileDetail !== undefined && (
                <EditProfileInfo
                  detail={profileDetail}
                  onSubmit={updateDetail}
                />
              )}

              {profileDetail !== undefined && (
                <FamilyDetail
                  detail={profileDetail}
                  onSubmit={updateDetail}
                />
              )}

              {/* {profileDetail !== undefined && (
                <AreaDetail
                  detail={profileDetail}
                  onSubmit={updateDetail}
                />
              )} */}

                
            </div>
          </div>
        </div>
      </section>

      {profileDetail !==undefined && profileDetail.is_paid == 1 &&
      <a href={`https://support.allenoverseas.com/student/dashboard/${form_number_encode}`} rel="noreferrer" target="_blank"  className="support_links"><i className="fa fa-key pe-2"></i> Support Help Desk</a>
      }
      </>
      }
    </>
  );
};

export default EditProfile;
